import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table, Badge } from "reactstrap";
import httpService from "../../services/httpService";

export default function PromoCodesList() {
  const [promoCodes, setPromoCodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    httpService.get("promocodes").then(({ data }) => {
      setPromoCodes(data);
      setLoading(false);
    });
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };

  if (loading) return <div className="container mt-3">Loading...</div>;

  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Promo Codes</h2>
        <Link to="/promocodes/new">
          <Button color="primary">Create New</Button>
        </Link>
      </div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Type</th>
            <th>Discount</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Times Used</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {promoCodes.map((pc) => (
            <tr key={pc.id}>
              <td>
                <Link to={`/promocodes/${pc.id}`}>{pc.code}</Link>
              </td>
              <td>{pc.name}</td>
              <td>{pc.type === 0 ? "Percent" : "Amount"}</td>
              <td>
                {pc.type === 0 ? `${pc.discount}%` : `€${pc.discount}`}
              </td>
              <td>{formatDate(pc.dateTimeRange?.start)}</td>
              <td>{formatDate(pc.dateTimeRange?.end)}</td>
              <td>{pc.timesUsed}</td>
              <td>
                {pc.isActive ? (
                  <Badge color="success">Active</Badge>
                ) : (
                  <Badge color="secondary">Inactive</Badge>
                )}
              </td>
            </tr>
          ))}
          {promoCodes.length === 0 && (
            <tr>
              <td colSpan="8" className="text-center">
                No promo codes found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}
